// extracted by css-extract-rspack-plugin
export default {"example":"trackingCodeTooltip_example__7YDsS","section-body":"trackingCodeTooltip_section-body__OuUFF","sectionBody":"trackingCodeTooltip_section-body__OuUFF"};